<template>
  <div class="editpassword">
    <headerBar title="修改密码"></headerBar>
    <div class="edit">
      <div class="form-input">
        旧密码：
        <input type="password" placeholder="请输入旧密码" v-model="old_password" />
      </div>
      <div class="form-input">
        新密码：
        <input type="password" placeholder="请输入新密码" v-model="new_password" />
      </div>
      <div class="form-input">
        确认密码：
        <input type="password" placeholder="请再输入一次新密码" v-model="re_password" />
      </div>
      <!--解决浏览器自动填充密码的问题-->
      <input type="password" autoComplete="new-password" hidden />
    </div>
    <div class="kuang" @click="submitBtn">
      <div class="bgmask"></div>
      <p>确认修改</p>
    </div>
  </div>
</template>

<script>
import { Toast, MessageBox } from 'mint-ui';
export default {
  data() {
    return {
      old_password: '',
      new_password: '',
      re_password: ''
    };
  },
  destroyed() {
    MessageBox.close();
  },
  methods: {
    submitBtn() {
		
      if (!this.old_password || !this.new_password || !this.re_password) {
        Toast('请输入密码');
        return false;
      }
      
      if (this.old_password.length < 6 || this.new_password.length < 6) {
        Toast('密码长度最小不能低于6位');
        return false;
      }
      
      if (this.new_password != this.re_password) {
        Toast('两次密码不匹配');
        return false;
      }
	  
      MessageBox.confirm('是否修改?', '提示').then(action => {
        this.postData();
      });
    },
    postData() {
      
      this.$request.post(
        '/front/Appsto/stochpass',
        {
          id: window.localStorage.getItem('store_id'),
          token: window.localStorage.getItem('token'),
          old_password: this.old_password,
          new_password: this.new_password,
          re_password: this.re_password
        },
        res => {
          if (res.status == 1) {
            setTimeout(() => {
              this.$router.go(-1);
            }, 1200);
          }
          Toast(res.msg);
        }
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.editpassword {
  height: 100%;
  padding-top: 2rem;
  background: white;
  .kuang {
    margin-top: 1rem;
    border-color: #299e72;
    .bgmask {
      background: #299e72;
    }
    p {
      color: #299e72;
      font-size: 0.38rem;
    }
  }
  .form-input {
    width: 100%;
    height: 1.1rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #cccccc;
    position: relative;
    padding: 0 0.4rem;
  }
  .form-input input {
    height: 1rem;
    width: 5rem;
    line-height: 1rem;
    font-size: 0.3rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/login/editPassword.vue